export default __webpack_public_path__ + "static/media/Learning_support_assistant-01.ec77b273.png";